import { useInfiniteQuery } from '@tanstack/react-query';
import { concat, isEmpty } from 'lodash';
import { type IAssemblyTagWithAssembliesCount } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

export const useGetAssemblyTagsWithAssembliesCount = (filters: string[] = []) =>
  useInfiniteQuery({
    queryKey: queryKeys.viewAssemblyTagsWithAssembliesCount.pagination(filters),
    queryFn: ({ pageParam = 1 }) =>
      fetchPaginatedAssemblytTagWithAssembliesCount(pageParam, filters),
    staleTime: Infinity,
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = lastPage ? allPages.length : 1;
      const totalPages = lastPage ? lastPage?.totalPages : 1;

      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    enabled: !isEmpty(filters),
  });

const fetchPaginatedAssemblytTagWithAssembliesCount = async (
  page: number,
  filters: string[],
) => {
  const response = await requestCCApi({
    url: `/viewAssemblyTagsWithAssembliesCount${generateQuery(
      [],
      concat(filters, [`count=true`, `page=${page}`]),
    )}`,
  });

  return {
    data: (response?.data ?? []) as IAssemblyTagWithAssembliesCount[],
    totalPages: response?.totalPages ?? 0,
    totalCount: response?.totalCount ?? 0,
  };
};
